import React from 'react';

export default function Footer() {
  return (
    <footer className="bg-black small text-center text-white-50">
      <div className="container">
        Copyright &copy; OSK Berlin GmbH
      </div>
    </footer>
  );
}
